/** Ordem dos 7 equipáveis (UI estilo Rust). */
export const ARMOR_SLOT_ORDER = [
    "armor-head",
    "armor-mask",
    "armor-chest",
    "armor-belt",
    "armor-hands",
    "armor-legs",
    "armor-feet",
];

export const OUTFIT_ARMOR_SLOT = "armor-chest";
